import { CoveragePlanCardUrl, CoveragePlanType } from '@cms-max/medicare-api-sdk'
import { Card } from '@cmsgov/ds-medicare-gov'
import { MyLink, MyLinkClickHandler } from 'components/MyLink'
import { useTranslation } from 'react-i18next'

import classes from './PlanCard.module.scss'
import { usePlanCardLink } from './usePlanCardLink'

type PartAPartBPlanCardProps = {
  partAEffectiveDate: string
  partBEffectiveDate: string
  urls: Array<CoveragePlanCardUrl>
  onLinkClick: MyLinkClickHandler
}
export const PartAPartBPlanCard = ({
  partAEffectiveDate,
  partBEffectiveDate,
  urls,
  onLinkClick
}: PartAPartBPlanCardProps) => {
  const { t, i18n } = useTranslation('accountHome')
  const urlObj = usePlanCardLink({
    language: i18n.language,
    type: CoveragePlanType.OmPartA,
    urls
  })

  return (
    <Card
      className={`ds-u-padding--3 ds-u-display--flex ds-u-flex-direction--column ${classes.card}`}
    >
      <div className="ds-text-body--md">
        {t('currentPlans.combinedCard.type')}
      </div>
      <div className="ds-text-body--lg ds-u-margin-bottom--0 ds-u-font-weight--semibold my-u-whitespace-nowrap">
        <div>{t('currentPlans.combinedCard.partAName')}</div>
        <div>{t('currentPlans.combinedCard.partBName')}</div>
      </div>
      <hr className="ds-u-border-bottom--1 my-u-width--full ds-u-margin-y--2" />
      <div className="my-u-flex-grow-1">
        <div className="ds-text-body--md">
          {t('currentPlans.startDateHeading', { count: 2 })}
        </div>
        <div className="ds-text-body--lg ">
          <div>
            {t('currentPlans.combinedCard.partALabel')}:{' '}
            <span className='ds-u-font-weight--semibold'>{partAEffectiveDate}</span>
          </div>
          <div>
            {t('currentPlans.combinedCard.partBLabel')}:{' '}
            <span className='ds-u-font-weight--semibold'>{partBEffectiveDate}</span>
          </div>
        </div>
      </div>
      <div className="ds-text-body--md">
        {urlObj ? <MyLink href={urlObj.url} onClick={onLinkClick}>{urlObj.text}</MyLink> : null}
      </div>
    </Card>
  )
}
